import { useEffect, useState } from 'react';

function useCountdown() {
  const target = useNextRound();
  const [remain, setRemain] = useState(target - Date.now());
  useEffect(() => {
    const timer = setInterval(() => {
      setRemain(Math.max(0, target - Date.now()));
    }, 1000);
    return () => clearInterval(timer);
  }, [target]);
  const s = Math.floor(remain / 1000);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    sec: s % 60,
  };
}

function useNextRound() {
  const [t, setT] = useState<number>(0);
  useEffect(() => {
    const now = new Date();
    const next = new Date(now);
    next.setDate(now.getDate() + ((3 - now.getDay() + 7) % 7 || 7));
    next.setHours(20, 0, 0, 0);
    setT(next.getTime());
  }, []);
  return t;
}

const Floating = [
  { i: 'ri-fire-fill', cls: 'text-melon-500', top: '12%', left: '8%' },
  { i: 'ri-vip-crown-fill', cls: 'text-sun-400', top: '18%', left: '82%' },
  { i: 'ri-vip-diamond-fill', cls: 'text-leaf-400', top: '64%', left: '6%' },
  { i: 'ri-heart-3-fill', cls: 'text-melon-400', top: '70%', left: '88%' },
];

export default function Hero() {
  const { d, h, m, sec } = useCountdown();
  const box = 'flex flex-col items-center justify-center w-16 md:w-20 h-16 md:h-20 rounded-2xl bg-white/95 shadow-sm';
  const num = 'font-display text-2xl md:text-4xl font-bold text-melon-600';
  const label = 'text-[11px] md:text-xs text-ink/60 mt-0.5';

  return (
    <section id="home" className="relative w-full overflow-hidden bg-ink">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20summer%20celebration%20stage%20with%20watermelon%20themed%20party%20decorations%2C%20spotlight%20beams%20and%20confetti%20bursts%2C%20deep%20rich%20raspberry%20red%20and%20coral%20tone%20background%2C%20glowing%20golden%20light%20particles%2C%20festive%20concert%20atmosphere%2C%20dramatic%20warm%20lighting%20for%20readable%20overlay%20text%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=chigua-hero-2026-x1&orientation=landscape"
        alt="吃瓜大赛投票打榜活动舞台背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-ink"></div>

      {Floating.map((f, idx) => (
        <i
          key={idx}
          className={`${f.i} ${f.cls} absolute text-2xl md:text-3xl animate-float-up`}
          style={{ top: f.top, left: f.left, animationDelay: `${idx * 1.4}s` }}
        ></i>
      ))}

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 pt-32 md:pt-40 pb-20 md:pb-28 w-full">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs md:text-sm font-semibold rounded-full bg-white/15 text-white backdrop-blur">
            <i className="ri-flashlight-fill text-sun-400"></i>第 5 季 · 全网火热投票中
          </span>
          <h1 className="mt-5 font-display font-extrabold text-4xl md:text-6xl lg:text-7xl leading-[1.08] text-white">
            吃瓜大赛
            <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-sun-400 via-melon-300 to-melon-400">
              投票打榜通道已开启
            </span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-white/85 leading-relaxed max-w-2xl">
            实时更新人气排行榜与 PK 助力数据，为你支持的选手拉票、打榜、围观激烈对决。
            点开即看当前票数走势、热门选手排名与最新助力攻略。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#ranking"
              className="inline-flex items-center gap-2 whitespace-nowrap px-7 py-3.5 text-sm md:text-base font-bold rounded-full bg-gradient-to-r from-sun-400 to-sun-500 text-ink hover:brightness-105 transition-all cursor-pointer"
            >
              <i className="ri-fire-fill"></i>进入投票打榜
            </a>
            <a
              href="#pk"
              className="inline-flex items-center gap-2 whitespace-nowrap px-7 py-3.5 text-sm md:text-base font-semibold rounded-full bg-white/15 text-white hover:bg-white/25 transition-all backdrop-blur cursor-pointer"
            >
              <i className="ri-vip-crown-2-line"></i>围观人气PK
            </a>
          </div>

          <div className="mt-10">
            <p className="text-xs md:text-sm font-medium tracking-widest text-white/70 mb-3">本轮打榜冲刺结束倒计时</p>
            <div className="flex gap-2.5 md:gap-3">
              {[d, h, m, sec].map((v, idx) => (
                <div key={idx} className={box}>
                  <span className={num}>{String(v).padStart(2, '0')}</span>
                  <span className={label}>{['天', '时', '分', '秒'][idx]}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}